const calc = (selected: number, used: number) =>
  selected - used < 0 ? Math.abs(selected - used) : 0;

export interface SlotLimitExceeded {
  jobs: number;
  exceeded: boolean;
}

export const calculateSlotsLimitExceeded = (
  selectedSlots: number,
  usedJobSlots: number,
): SlotLimitExceeded => {
  const jobs = calc(selectedSlots, usedJobSlots);

  return {
    jobs,
    exceeded: jobs > 0,
  };
};
